import React, { Component } from 'react';
import { evaluate } from '@tencent/workbench';
import Select from '@tencent/dui/lib/components/Select';
import formStyle from '../form-item.less.js';
import styles from './select.less.js';

class SelectFormItem extends Component {
    constructor() {
        var _a;
        super(...arguments);
        this.value = (_a = this.props.defaultValue) !== null && _a !== void 0 ? _a : 'undefined';
        this.handleChange = (id) => {
            var _a, _b;
            this.value = id;
            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, id);
            this.forceUpdate();
        };
    }
    render() {
        const options = evaluate(this.props.options, { selectOptions: [] });
        return React.createElement(Select, { onChange: this.handleChange, value: evaluate(this.props.value, this.value), containerClassName: formStyle['form-item-single'], className: styles.select, textStyle: { fontSize: 12 }, style: { padding: '6px 4px 6px 6px' } }, options === null || options === void 0 ? void 0 : options.selectOptions.map(option => React.createElement(Select.Option, { key: option.key, value: option.key }, option.content)));
    }
}

export { SelectFormItem };
//# sourceMappingURL=select.js.map
